export default {
  root: '/',
  logout: '/logout',
  recovery: '/recovery',
  profileSettings: '/profile-settings',
  demands: '/demands',
  demandReports: '/demands/:id/reports',
  demand: '/demands/:id',
  frame: '/boards/:id',
  boardSettings: '/boards/settings',
  qa: '/qa'
} as const
